export default __webpack_public_path__ + "static/media/Desktop-SolarRoof.9eb2e602.jpeg";